import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import PropTypes from 'prop-types';

import { cn } from '../../libraries/tailwind/utils';
import Entity from '../renders/entity/Entity';

const Switch = React.forwardRef((
  { className, wrapperClassName, thumbClassName, entityClassName, name, disabled, entity, namespace, isLabelOff = false, ...props }
  , ref
) => {
  return (
    <div className={cn('flex gap-2 m-0 items-center', wrapperClassName)}>
      <SwitchPrimitives.Root
        disabled={disabled}
        className={cn(
          // eslint-disable-next-line max-len
          'peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input',
          className
        )}
        name={name}
        {...props}
        ref={ref}>
        <SwitchPrimitives.Thumb
          className={cn(
            // eslint-disable-next-line max-len
            'pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0',
            thumbClassName
          )} />
      </SwitchPrimitives.Root>
      {!isLabelOff &&
        <Entity
          entity={entity}
          namespace={namespace}
          className={entityClassName}
        />}
    </div>
  );
});
Switch.displayName = SwitchPrimitives.Root.displayName;

Switch.propTypes = {
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
  thumbClassName: PropTypes.string,
  entityClassName: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  entity: PropTypes.string,
  namespace: PropTypes.string,
  isLabelOff: PropTypes.bool
};

export default Switch;
